import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { GET_SURGE_TEMPLATE, GET_SURGE_TEMPLATE_SUCCESS, GET_SURGE_TEMPLATE_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getSurgeTemplate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };

    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-templates`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_SURGE_TEMPLATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SURGE_TEMPLATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SURGE_TEMPLATE_ERROR, payload: error });
  }
}

export function* watchgetSurgeTemplate() {
  yield takeEvery(GET_SURGE_TEMPLATE, getSurgeTemplate);
}

function* getSurgeTemplateSaga() {
  yield all([fork(watchgetSurgeTemplate)]);
}

export default getSurgeTemplateSaga;
